const FAV_STORAGE_KEY = 'vurgun.casino.favorites';
const LAST_PLAYED_KEY = 'vurgun.casino.lastPlayed';
const LIKED_KEY = 'vurgun.casino.liked';
const LAST_PLAYED_MAX = 40;

function readIdList(key) {
  try {
    const raw = localStorage.getItem(key);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.map(String).filter(Boolean) : [];
  } catch {
    return [];
  }
}

function writeIdList(key, ids) {
  try {
    localStorage.setItem(key, JSON.stringify(ids));
  } catch {
    /* ignore quota */
  }
}

export function readFavoriteIds() {
  return readIdList(FAV_STORAGE_KEY);
}

export function writeFavoriteIds(ids) {
  writeIdList(FAV_STORAGE_KEY, [...new Set((ids || []).map(String).filter(Boolean))]);
}

export function readLastPlayedIds() {
  return readIdList(LAST_PLAYED_KEY);
}

export function pushLastPlayedId(gameId) {
  const id = String(gameId || '').trim();
  if (!id) return readLastPlayedIds();
  const next = [id, ...readLastPlayedIds().filter((x) => x !== id)].slice(0, LAST_PLAYED_MAX);
  writeIdList(LAST_PLAYED_KEY, next);
  return next;
}

export function readLikedIds() {
  return readIdList(LIKED_KEY);
}

export function isGameLiked(gameId) {
  const id = String(gameId || '').trim();
  if (!id) return false;
  return readLikedIds().includes(id);
}

/** Toggle like; returns { liked, ids }. */
export function toggleGameLike(gameId) {
  const id = String(gameId || '').trim();
  if (!id) return { liked: false, ids: readLikedIds() };
  const ids = readLikedIds();
  const liked = ids.includes(id);
  const next = liked ? ids.filter((x) => x !== id) : [...ids, id];
  writeIdList(LIKED_KEY, next);
  return { liked: !liked, ids: next };
}
